module.exports = {"330602001":"塔山街道","330602002":"府山街道","330602004":"北海街道","330602005":"城南街道","330602006":"稽山街道","330602007":"迪荡街道","330602008":"东湖街道","330602009":"灵芝街道","330602010":"东浦街道","330602011":"鉴湖街道","330602012":"斗门街道","330602013":"皋埠街道","330602014":"马山街道","330602015":"孙端街道","330602016":"陶堰街道","330602017":"沥海街道","330602108":"富盛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330602.json
// module id = 1094
// module chunks = 0